import React, { useState } from "react";
import { Select } from "antd";
import { SqlFunction } from "../types2";
import functions from "../functions.json";
import { FunctionOutlined } from "@ant-design/icons";
import { 
  FontSizeOutlined, 
  NumberOutlined, 
  CalculatorOutlined, 
} from "@ant-design/icons";

type ReturnType = "string" | "number" | "integer" | "any";

const getTypeIcon = (returnType: ReturnType) => {
  const iconMap: Record<ReturnType, React.ReactNode> = {
    string: <FontSizeOutlined />,
    number: <NumberOutlined />,
    integer: <CalculatorOutlined />,
    any: <FunctionOutlined />,
  };
  return iconMap[returnType] || <FunctionOutlined />;
};

export const FunctionExpression: React.FC<{
  value: string;
  onChange: (functionObj: any) => void;
}> = ({ value, onChange }) => {
  const [selectedFunction, setSelectedFunction] = useState<SqlFunction | null>(
    null
  );

  React.useEffect(() => {
    if (value) {
      //handleChange(value);
    } else if (functions.length > 0) {
      // If no value is provided, select the first function
      handleChange(functions[0].name);
    }
  }, []);

  const functionOptions = functions.map((func: any) => ({
    label: (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>{func.name}</span>
        {/* <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            {getTypeIcon(func.returnType)}
            <span style={{ fontSize: '0.8em', color: 'gray' }}>{func.returnType}</span>
          </div> */}
      </div>
    ),
    value: func.name,
  }));

  const handleChange = (value: string) => {
    const selectedFunc = functions.find((f) => f.name === value);
    onChange(selectedFunc);
    setSelectedFunction(selectedFunc || null);
  };

  return (
    <div>
      <Select
        showSearch
        value={value}
        style={{ width: "200px" }}
        placeholder="Select a SQL Function"
        optionFilterProp="children"
        onChange={handleChange}
        filterOption={(input, option: any) =>
          option.value.toLowerCase().includes(input.toLowerCase())
        }
        options={functionOptions}
      />
    </div>
  );
}; 